"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboard = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
require("../../../TdWebtoolkitControls/controls/Chart/Chart");
require("../../../TdWebtoolkitControls/controls/List/List");
const List_1 = require("../../../TdWebtoolkitControls/controls/List/List");
const SelectionContext_1 = require("../../../TdWebtoolkitControls/controls/Menu/SelectionContext");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
const LocalStorageManager_1 = require("../../../TdWebtoolkitControls/javascript/LocalStorageManager");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
require("./dashboardQuerySelector.less");
const $ = require("jquery");
const m = require("../SynView");
let r_css = require("./dashboard.tmpl.less");
/**
 * Trigger which can change selection context
 * in the actual view
 */
var SelectionContextTriggers;
(function (SelectionContextTriggers) {
    /**
     * List is selected
     */
    SelectionContextTriggers[SelectionContextTriggers["listSelected"] = 0] = "listSelected";
})(SelectionContextTriggers || (SelectionContextTriggers = {}));
class dashboard extends m.SynView {
    //#endregion Controls
    //#endregion MEMBER letIABLES
    //#region CONSTRUCTOR
    constructor() {
        super();
    }
    //#endregion CONSTRUCTOR
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
        this.m_lists = [];
        this.m_localStorageKeyFullList = "fullQueryList";
        this.m_localStorageKeyActiveList = "activeQueryList";
        this.m_localStorageKeyInactiveList = "inactiveQueryList";
        this.icon = "fa-tachometer";
    }
    renderContents() {
        const that = this;
        that.m_$userImage = that.m_$container.find("#user-image");
        that.m_$userData = that.m_$container.find("#user-data");
        that.m_$buttonPane = that.m_$container.find("#button-pane");
        that.m_$widgetPane = that.m_$container.find("#widget-pane");
        that.initDashboard();
        that.logView();
        if (typeof window.synDesktopApp !== "undefined") {
            $(".innerContainer").data("kendoSplitter").collapse(".sideNav");
            $(".appContainer").data("kendoSplitter").collapse(".menuPane");
        }
    }
    getSelectionContext() {
        for (let i = 0; i < this.m_lists.length; i++) {
            const $list = $("#list_" + this.m_lists[i]);
            if ($list.synList("isFocused")) {
                return {
                    parentControl: false,
                    normalParentContext: {
                        parentRelId: SelectionContext_1.SpecialRelIds.Undefined
                    },
                    parentControlParentContext: {
                        parentRelId: SelectionContext_1.SpecialRelIds.Undefined
                    },
                    selectedIds: $list.synList("getSelectedIds")
                };
            }
        }
        return super.getSelectionContext();
    }
    forceRefresh(modificationInfo) { }
    //#endregion Inherited from SynView
    //#region Helpers
    updateDashboardIds(dashboardIds) {
        const that = this;
        const fullList = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyFullList);
        const activeList = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyActiveList);
        const inactiveList = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyInactiveList);
        if (fullList && activeList && inactiveList) {
            // Local storage is initialized
            let fullListJSON = JSON.parse(fullList);
            let activeListJSON = JSON.parse(activeList);
            let inactiveListJSON = JSON.parse(inactiveList);
            // Check if there are new entries
            $.each(dashboardIds, (idx, entry) => {
                if (!fullListJSON.includes(entry.id)) {
                    fullListJSON.push(entry.id);
                    if (entry.initiallyVisible === "Y")
                        activeListJSON.push(entry.id);
                    else
                        inactiveListJSON.push(entry.id);
                }
            });
            // Check if there are deleted entries
            let queriesToDelete = [];
            $.each(fullListJSON, (idx, queryId) => {
                let isDeleted = true;
                $.each(dashboardIds, (idx, entry) => {
                    if (queryId === entry.id) {
                        isDeleted = false;
                        return false;
                    }
                });
                if (isDeleted)
                    queriesToDelete.push(queryId);
            });
            $.each(queriesToDelete, (idx, queryId) => {
                let fullListIndex = fullListJSON.indexOf(queryId);
                if (fullListIndex > -1)
                    fullListJSON.splice(fullListIndex, 1);
                let activeListIndex = activeListJSON.indexOf(queryId);
                if (activeListIndex > -1)
                    activeListJSON.splice(activeListIndex, 1);
                let inactiveListIndex = inactiveListJSON.indexOf(queryId);
                if (inactiveListIndex > -1)
                    inactiveListJSON.splice(inactiveListIndex, 1);
            });
            // Save changes to local storage
            LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyFullList, JSON.stringify(fullListJSON));
            LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyActiveList, JSON.stringify(activeListJSON));
            LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyInactiveList, JSON.stringify(inactiveListJSON));
            return true;
        }
        else
            return false;
    }
    initDashboard() {
        const that = this;
        that.m_$buttonPane.children().remove();
        that.m_$widgetPane.children().remove();
        that.m_$userData.children().remove();
        that.m_$userImage.children().remove();
        if (that.m_$querySelectorButton) {
            that.m_$querySelectorButton.remove();
            that.m_$querySelectorButton = undefined;
        }
        Utilities_1.synUtil.getAJAXData({
            url: Utilities_1.synUtil.getWSUrl("ProfileDashboard"),
            method: "POST",
            done(config) {
                if (config.buttons) {
                    // Remove duplicate buttons
                    let uniqueButtons = [];
                    $.each(config.buttons, (idx, button) => {
                        let isUnique = true;
                        $.each(uniqueButtons, (idx, uniqueButton) => {
                            if (button.name === uniqueButton.name && button.url === uniqueButton.url) {
                                isUnique = false;
                                return false;
                            }
                        });
                        if (isUnique)
                            uniqueButtons.push(button);
                    });
                    // Create buttons
                    $.each(uniqueButtons, (idx, button) => {
                        let link = $("<a class='k-button' />")
                            .attr("href", button.url)
                            .text(button.name)
                            .appendTo(that.m_$buttonPane);
                        let buttonUrl = (button.url).toLowerCase().trim();
                        if ((buttonUrl.indexOf("syneris://") > -1) || (buttonUrl.length >= 9 && buttonUrl.substr(0, 9) === "synerisws"))
                            link.attr("target", "_self");
                        else
                            link.attr({ "target": "_blank", "rel": "noopener noreferrer" });
                        that.m_$buttonPane.append($("<br />"));
                    });
                }
                Utilities_1.synUtil.getAJAXData({
                    url: Utilities_1.synUtil.getWSUrl("UserInfo"),
                    done(dataJSON) {
                        return tslib_1.__awaiter(this, void 0, void 0, function* () {
                            let instance = yield Instance_1.Instance.fromJSON(dataJSON.instance);
                            if (config.userDisplayFields) {
                                let strDisplayFields = "<h3>";
                                $.each(config.userDisplayFields, (idx, field) => {
                                    if (idx > 0) {
                                        strDisplayFields += " ";
                                    }
                                    strDisplayFields += kendo.htmlEncode(instance.items[field].valueToString());
                                });
                                strDisplayFields += "</h3>";
                                that.m_$userData.append(strDisplayFields);
                            }
                            if (config.userAdditionalFields) {
                                $.each(config.userAdditionalFields, (idx, field) => {
                                    if (idx > 0)
                                        that.m_$userData.append($("<br />"));
                                    let val = instance.items[field].multiValue ? instance.items[field].valueAsArray : [instance.items[field].value];
                                    if (val) {
                                        for (let i = 0; i < val.length; i++) {
                                            if (val[i]) {
                                                if (i > 0)
                                                    that.m_$userData.append($("<br />"));
                                                that.m_$userData.append(kendo.htmlEncode(val[i].toString()));
                                            }
                                        }
                                    }
                                });
                            }
                            let url = Utilities_1.synUtil.getWSUrl("InstancePreview") + instance.id.value + '?csrfToken=' + Utilities_1.synUtil.requestVerificationToken;
                            Utilities_1.synUtil.getAJAXData({
                                url,
                                done(prevdata) {
                                    if (prevdata && !prevdata.isHTML && !(prevdata.jPreviewable && prevdata.jPreviewableType !== "image"))
                                        that.m_$userImage.append('<img src="' + Utilities_1.synUtil.getWSUrl("InstancePreview") + instance.id.value + '/1?csrfToken=' + Utilities_1.synUtil.requestVerificationToken + '">');
                                    else
                                        that.m_$userImage.append('<i class="fa fa-user" style="font-size:180px;color:#999;"></i>');
                                }
                            });
                            // Updates the local storage
                            let localStorageInitialized = that.updateDashboardIds(config.dashboardIds);
                            let fullListJSON;
                            let activeListJSON;
                            let inactiveListJSON;
                            if (localStorageInitialized) {
                                let fullList = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyFullList);
                                fullListJSON = JSON.parse(fullList);
                                let activeList = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyActiveList);
                                activeListJSON = JSON.parse(activeList);
                                let inactiveList = LocalStorageManager_1.LocalStorageManager.getItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyInactiveList);
                                inactiveListJSON = JSON.parse(inactiveList);
                            }
                            else {
                                fullListJSON = [];
                                activeListJSON = [];
                                inactiveListJSON = [];
                                $.each(config.dashboardIds, (idx, entry) => {
                                    fullListJSON.push(entry.id);
                                    if (entry.initiallyVisible === "Y")
                                        activeListJSON.push(entry.id);
                                    else
                                        inactiveListJSON.push(entry.id);
                                });
                            }
                            // Get active queries
                            $.each(activeListJSON, (idx, id) => {
                                that.initWidget(id, config.colLayoutName, config.showHeaders, config.dashboardIds);
                            });
                            that.m_$widgetPane.append($("<div style='clear: both' />"));
                            // Add dashboard query selector
                            that.m_$querySelectorButton = $("<button type='button' class='k-button' id='querySelectorButton'><i class='fa fa-cog'></i></button>").on("click", function () {
                                let windowData = Utilities_1.synUtil.popupWindow({
                                    title: Utilities_1.synUtil.Strings.getValue("dashboard.queryselector"),
                                    width: 600,
                                    height: 400,
                                    modal: true
                                });
                                let windowId = "popup_" + windowData.guid;
                                let querySelectorMarkup = require("./dashboardQuerySelector.tmpl.htm");
                                let querySelectorData = {
                                    synUtil: Utilities_1.synUtil,
                                    windowId,
                                    okButtonId: "okButton_" + Utilities_1.synUtil.getGUID(),
                                    cancelButtonId: "cancelButton_" + Utilities_1.synUtil.getGUID(),
                                    inactiveList: Utilities_1.synUtil.Strings.getValue("dashboard.inactivequeries"),
                                    activeList: Utilities_1.synUtil.Strings.getValue("dashboard.activequeries"),
                                };
                                let template = kendo.template(querySelectorMarkup);
                                windowData.contentDiv.html(template(querySelectorData));
                                windowData.contentDiv.css("height", (windowData.contentDiv.parent().height() - 20) + "px");
                                // Create linked lists
                                function queryIdToName(id) {
                                    let name;
                                    config.dashboardIds.forEach((element) => {
                                        if (element.id === id) {
                                            name = element.name;
                                            return false;
                                        }
                                    });
                                    if (name)
                                        return name;
                                    else
                                        throw new Error(("Should never happen! dashboard.ts queryIdToName couldn't find id!"));
                                }
                                function queryNameToId(name) {
                                    let id;
                                    config.dashboardIds.forEach((element) => {
                                        if (element.name === name) {
                                            id = element.id;
                                            return false;
                                        }
                                    });
                                    if (id)
                                        return id;
                                    else
                                        throw new Error(("Should never happen! dashboard.ts queryNameToId couldn't find name!"));
                                }
                                inactiveListJSON.forEach((element) => {
                                    $("#listInactive").append("<li class='dashboard-list-item'>" + queryIdToName(element) + "</li>");
                                });
                                activeListJSON.forEach((element) => {
                                    $("#listActive").append("<li class='dashboard-list-item'>" + queryIdToName(element) + "</li>");
                                });
                                function placeholder(element) {
                                    return $("<li class='dashboard-list-item' id='placeholder'>&nbsp;</li>");
                                }
                                function hint(element) {
                                    return element.clone().addClass("hint");
                                }
                                $("#listInactive").kendoSortable({
                                    connectWith: "#listActive",
                                    placeholder,
                                    hint,
                                    change: () => { $("#" + querySelectorData.okButtonId).prop("disabled", false); },
                                });
                                $("#listActive").kendoSortable({
                                    connectWith: "#listInactive",
                                    placeholder,
                                    hint,
                                    change: () => { $("#" + querySelectorData.okButtonId).prop("disabled", false); },
                                });
                                $("#" + querySelectorData.okButtonId).on("click", () => {
                                    let newInactiveJSON = [];
                                    let newActiveJSON = [];
                                    $("#listInactive").children("li").each(function () {
                                        newInactiveJSON.push(queryNameToId($(this).text()));
                                    });
                                    $("#listActive").children("li").each(function () {
                                        newActiveJSON.push(queryNameToId($(this).text()));
                                    });
                                    if (!localStorageInitialized)
                                        LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyFullList, JSON.stringify(fullListJSON));
                                    LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyInactiveList, JSON.stringify(newInactiveJSON));
                                    LocalStorageManager_1.LocalStorageManager.setItem(LocalStorageManager_1.LocalStorageType.Dashboard, that.m_localStorageKeyActiveList, JSON.stringify(newActiveJSON));
                                    that.initDashboard();
                                    $("#" + windowId).data("kendoWindow").close();
                                });
                                $("#" + querySelectorData.cancelButtonId).on("click", () => {
                                    $("#" + windowId).data("kendoWindow").close();
                                });
                            });
                            that.m_$buttonPane.append(that.m_$querySelectorButton);
                        });
                    }
                });
            }
        });
    }
    initList(id, colLayoutName, showHeader) {
        const that = this;
        let listId = id.replace(/\|/g, "_");
        that.m_lists.push(listId);
        let $itemContainer = $("<div id='" + listId + "' class='col-sm-6' />").appendTo(that.m_$widgetPane);
        let $newItem = $("<div class='dashboardItem widget' />").appendTo($itemContainer);
        Utilities_1.synUtil.getInstance(id, (inst) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let $headerTitle = $("<div class='headerTitle'></div>")
                .attr({
                "class": "headerTable",
                "style": "border-top-left-radius: 15px; border-top-right-radius: 15px; background-color: #8bbb80;"
            })
                .text(inst.name.valueAsString);
            let $listContainer = $("<div class='listContainer'></div>").appendTo($newItem);
            let $list = $("<div />")
                .attr({
                "id": "list_" + listId,
                "data-listid": listId,
                "style": "border-radius: 15px; height: 433px; padding-top: 0px;"
            })
                .appendTo($listContainer);
            $headerTitle.appendTo($list);
            let listConfig;
            const dataItemGenerator = (ctx) => {
                return new Promise((resolve) => {
                    Utilities_1.synUtil.getAJAXData({
                        url: Utilities_1.synUtil.getWSUrl("InstanceChildren") + id + "/1",
                        requestData: {},
                        done(resultsId, textStatus, jqXHR, handlerKey) {
                            let headers = {};
                            if (handlerKey)
                                headers["X-WS-Affinity"] = handlerKey;
                            Utilities_1.synUtil.getAJAXData({
                                method: "POST",
                                url: Utilities_1.synUtil.getWSUrl("Results") + resultsId,
                                headers,
                                requestData: {
                                    fieldNames: JSON.stringify(ctx.columnNames)
                                },
                                done: (data) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                                    const children = yield Instance_1.Instance.fromJSONArray(data.data);
                                    resolve(List_1.instancesToListDataItems(children));
                                }),
                            });
                            that.scheduleResize();
                        }
                    });
                });
            };
            if (colLayoutName !== "") {
                listConfig = {
                    selectionMode: "Single",
                    dataItemGenerator,
                    columnOptions: {
                        layoutName: colLayoutName,
                        catId: 1,
                        catIdDependent: true,
                    }
                };
            }
            else {
                listConfig = {
                    selectionMode: "Single",
                    dataItemGenerator,
                    columnOptions: {
                        parentId: id,
                    }
                };
            }
            yield $list
                .off("selectionChanged").on("selectionChanged", function (evt, ids) {
                let listId = $(evt.target).attr("data-listid");
                for (let i = 0; i < that.m_lists.length; i++)
                    $("#list_" + that.m_lists[i]).synList("focus", listId === that.m_lists[i]);
                that.updateSelectionContext();
            })
                .off("fetchedIds").on("fetchedIds", (_evt, ids) => {
                if (ids.length === 0) {
                    $list.children(".k-grid-header").css("display", "none");
                    $list.children(".k-grid-content").css("display", "none");
                    $list.children(".k-pager-wrap").children("a").css("display", "none");
                    $list.children(".k-pager-wrap").children("ul").css("display", "none");
                    $list.children(".k-pager-wrap").children(".k-pager-info").css("float", "left");
                    $list.css("height", "25px");
                }
            })
                .synList(listConfig);
            $list.attr("id").replace(/list_/, "").replace(/_/g, "|");
        }));
    }
    initChart(id) {
        const that = this;
        const chartId = id.replace(/\|/g, "_");
        const $itemContainer = $("<div id='" + chartId + "' class='col-sm-6' />").appendTo(that.m_$widgetPane);
        const $newItem = $("<div class='dashboardItem widget' />").appendTo($itemContainer);
        const $chartContainer = $("<div style='height: 450px; border-radius: 15px' class='listContainer'></div>").appendTo($newItem);
        const $chart = $("<div />")
            .attr({
            "id": "chart_" + chartId,
            "data-chartid": chartId,
            "style": "height: 450px; border-radius: 15px;"
        })
            .appendTo($chartContainer);
        $chart.synChart(id);
    }
    initWidget(id, colLayoutName, showHeader, dashboardIds) {
        const that = this;
        let type = "";
        let isquery = false;
        $.each(dashboardIds, (idx, entry) => {
            if (entry.id === id && entry.type != undefined) {
                type = entry.type;
                isquery = entry.isquery;
            }
        });
        if (isquery)
            that.initList(id, colLayoutName, showHeader);
        else if (type === "999999915")
            that.initChart(id);
    }
    scheduleResize() {
        const that = this;
        window.clearTimeout(that.resizeTimeoutId);
        that.resizeTimeoutId = window.setTimeout(() => { that.resizeControls(); }, 250);
    }
}
exports.dashboard = dashboard;
